import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from "rxjs/Subscription";
import { NotificationsService } from "angular2-notifications";

import { GUID, Param } from "app/brightserve/brightserve.module";
import { AtmistData } from "app/shared/shared.module";
import { AddonService } from "app/add-ons/addon.service";

@Component({
  selector: 'app-atmist-form',
  templateUrl: './atmist-form.component.html',
  styleUrls: ['./atmist-form.component.css']
})
export class ATMISTFormComponent implements OnInit {

    GetATMISTDataSubscription: Subscription;
    ATMISTData: AtmistData = new AtmistData();
    Today: Date = new Date();

    @Input() IncidentId: GUID;
    @Input() EnableAdd: boolean = false;

    constructor(private addonService: AddonService, private _notification: NotificationsService) { }


    ngOnInit() {

    }

    ngOnChanges() {
        if (this.IncidentId) {
            this.GetATMISTData();
        }
    }

    ngOnDestroy() {
        if (this.GetATMISTDataSubscription != null)
            this.GetATMISTDataSubscription.unsubscribe();
    }

    GetATMISTData() {
        if (this.IncidentId) {
            this.GetATMISTDataSubscription = this.addonService.GetATMISTData(this.IncidentId).subscribe(
                data => {
                    this.ATMISTData = data;
                    console.log(data);
                }, err => {
                    console.log(err);
                    this._notification.error("Data Error", "ATMIST data for this incident could not be obtained.");
                }
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/add-ons/ATMIST/atmist-form.component.ts